import { Tooltip, TooltipProps, IconButton, SxProps, Theme, SvgIconProps } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

type HintVariant = "help" | "info";

interface HintIconProps {
  /** The hint text to display */
  hint: string;
  /** Visual variant - "help" shows ?, "info" shows i */
  variant?: HintVariant;
  /** Tooltip placement */
  placement?: TooltipProps["placement"];
  /** Icon size */
  size?: "xs" | "small" | "medium";
  /** Custom styles for the icon button */
  sx?: SxProps<Theme>;
}

const iconMap = {
  help: HelpOutlineIcon,
  info: InfoOutlinedIcon,
};

export const HintIcon = ({ hint, variant = "help", placement = "top", size = "xs", sx }: HintIconProps) => {
  const Icon = iconMap[variant];
  const iconSize = size === "xs" ? 16 : undefined;
  const muiFontSize: SvgIconProps["fontSize"] | undefined =
    size === "xs" ? undefined : size === "small" ? "small" : "medium";

  return (
    <Tooltip title={hint} placement={placement} arrow>
      <IconButton
        size="small"
        sx={{
          color: "text.secondary",
          p: 0.25,
          "&:hover": {
            color: "primary.main",
            backgroundColor: "transparent",
          },
          ...sx,
        }}
        disableRipple
      >
        <Icon sx={iconSize ? { fontSize: iconSize } : undefined} fontSize={muiFontSize} />
      </IconButton>
    </Tooltip>
  );
};
